import { AreaMasterThemeModeConfig } from './types';

const light: AreaMasterThemeModeConfig = {
  areaMaster: {},
};

export default light;
